/* ==========================================================================
   MAAREE "never made" size handling  (17 Aug 2026)

   Mari's rule:
     - Size buttons NEVER cross out.
     - A size MAAREE never made is not shown at all, to avoid confusion.
     - Sold out, whether in the colour being viewed or in every colour, leaves the
       size looking completely normal and selectable. The buy button carries the
       message ("Email me when back in stock").
     - Crossing out is reserved for the COLOUR swatches, which
       product-grouping.liquid and buy-buttons.liquid already handle.

   This file marks never-made sizes with .mz-never-made.
   assets/maaree-size-rules.css hides that class and switches off every other
   stock-driven size treatment.

   ------------------------------------------------------------------------------
   TWO SOURCES OF "NEVER MADE"
   ------------------------------------------------------------------------------
   1. NO VARIANT EXISTS in any in-territory colourway. Derived automatically from
      <product-grouping>'s .rm-groupings__data. On Solidarity that is:
          28HH  30D  38GG  38H  38HH

   2. NEVER_MADE below: combinations that DO exist as Shopify variants but were
      never actually produced. Mari confirmed 28D and 28DD fall in this group --
      the Solidarity 28 band starts at an E cup. Because the variants exist and
      simply read as sold out, no amount of data inspection can tell them apart
      from a real size that happens to be out of stock, so they have to be named.

      THE BETTER FIX is to archive or delete those variants in Shopify, at which
      point they drop out of .rm-groupings__data and this list can be emptied.
      Until then, add any further never-produced combinations here.

      Format: the size token with the colour removed, uppercased, no spaces --
      exactly how product-grouping.liquid builds it. "28D", "28DD", or "XXL" for
      an alpha-sized product.
   ------------------------------------------------------------------------------

   Note on scope: <product-grouping> filters colourways to the shopper's warehouse
   territory, so source 1 really means "not offered in any colourway we can ship to
   you". Right for a shopper, but the hidden set can differ between markets.

   .mz-never-made is written ONLY by this file. maaree-pdp.js never touches it, so
   the two cannot fight.
   ========================================================================== */
(function () {
  'use strict';

  /* Exists as a Shopify variant, but was never produced. See note 2 above. */
  var NEVER_MADE = ['28D', '28DD'];

  var FORCED = {};
  NEVER_MADE.forEach(function (s) { FORCED[('' + s).toUpperCase().replace(/\s+/g, '')] = true; });

  function norm(s) { return ('' + s).toUpperCase().replace(/\s+/g, ''); }

  function swatchText(l) {
    // data-uk is the raw UK value written server-side by swatch.liquid. The UK/US
    // size-unit toggle rewrites the visible text, so never read textContent first.
    var uk = l.getAttribute('data-uk');
    if (uk) return uk.trim();
    var s = l.querySelector('span');
    return ((s ? s.textContent : l.textContent) || '').trim();
  }

  /* Every size token that exists as a real variant in any in-territory colourway,
     minus anything explicitly listed as never produced. */
  function madeSet() {
    var pg = document.querySelector('product-grouping');
    if (!pg) return null;
    var el = pg.querySelector('.rm-groupings__data');
    if (!el) return null;
    var json;
    try { json = JSON.parse(el.textContent); } catch (e) { return null; }
    var raw = pg.getAttribute('data-index');
    var idx = (raw && raw !== 'n/a') ? parseInt(raw, 10) : NaN;
    if (isNaN(idx)) return null;

    var made = {};
    Object.keys(json).forEach(function (pid) {
      var vs = (json[pid] && json[pid].variants) || {};
      Object.keys(vs).forEach(function (vid) {
        var parts = ('' + vs[vid].options).split(',').map(function (x) { return x.trim(); });
        parts.splice(idx, 1);                 // drop the colour, same as product-grouping does
        var k = norm(parts.join(','));
        if (k && !FORCED[k]) made[k] = true;  // FORCED entries are treated as never made
      });
    });
    return Object.keys(made).length ? made : null;
  }

  function mark(l, on) {
    if (l.classList.contains('mz-never-made') !== on) l.classList.toggle('mz-never-made', on);
  }

  function clearAll(picker) {
    picker.querySelectorAll('.block-swatch').forEach(function (l) { mark(l, false); });
  }

  function apply() {
    var picker = document.querySelector('variant-picker[context="main_product"]');
    if (!picker) return;

    var made = madeSet();
    if (!made) {
      // No grouping data (single-colour product). Fall back to the explicit list only.
      picker.querySelectorAll('.block-swatch').forEach(function (l) {
        mark(l, !!FORCED[norm(swatchText(l))]);
      });
      return;
    }

    var combined = picker.querySelector('.variant-picker__combined-selector');

    if (!combined) {
      // Single-row alpha picker (Empower, Uplift, Seamless, hoodies, shorts). The
      // picker only renders sizes that exist as variants of THIS product, so the
      // only way one is never-made is the explicit list.
      picker.querySelectorAll('fieldset.variant-picker__option .variant-picker__option-values:not(.hidden) .block-swatch')
        .forEach(function (l) { mark(l, !!FORCED[norm(swatchText(l))]); });
      return;
    }

    var ubRow = combined.querySelector('fieldset .variant-picker__option-values:not(.hidden)');
    var cupRow = combined.querySelector('.variant--cup');
    var bands = ubRow ? Array.prototype.slice.call(ubRow.querySelectorAll('.block-swatch')) : [];
    var cups = cupRow ? Array.prototype.slice.call(cupRow.querySelectorAll('.block-swatch')) : [];
    var checkedBand = ubRow ? ubRow.querySelector('input:checked') : null;
    var band = checkedBand ? checkedBand.value.trim() : null;

    // A cup is hidden when the SELECTED band plus that cup was never made.
    cups.forEach(function (l) {
      mark(l, band ? !made[norm(band + swatchText(l))] : false);
    });

    // A band is hidden only when no cup under it was ever made at all.
    bands.forEach(function (l) {
      var b = swatchText(l);
      var anyMade = cups.some(function (c) { return !!made[norm(b + swatchText(c))]; });
      mark(l, !anyMade);
    });
  }

  /* rAF gives a paint-aligned update in the common case, but it is SUSPENDED in
     hidden or backgrounded tabs, so on its own the update can simply never land.
     A timer is the safety net. maaree-pdp.js's own scheduleRebuild() uses exactly
     this belt-and-braces pattern for the same reason. apply() only writes when a
     class actually differs, so running it twice is harmless. */
  function schedule() {
    if (schedule._raf == null) {
      schedule._raf = requestAnimationFrame(function () {
        schedule._raf = null;
        apply();
      });
    }
    clearTimeout(schedule._t);
    schedule._t = setTimeout(apply, 60);
  }

  function boot() {
    if (window.__maareeNeverMade) return;
    window.__maareeNeverMade = true;
    apply();
    // Changing the band changes which cups were never made, so recompute on the
    // native (synchronous) change as well as the theme's async variant:change.
    document.addEventListener('change', function (e) {
      var p = e.target && e.target.closest ? e.target.closest('variant-picker[context="main_product"]') : null;
      if (p) schedule();
    }, true);
    document.addEventListener('variant:change', schedule);
    window.addEventListener('load', schedule);
    setTimeout(schedule, 600);
    setTimeout(schedule, 1600);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
